﻿'use strict';


import Axios from "axios";
import { TweenLite, CSSPlugin, ScrollToPlugin } from "gsap/all";
const plugins = [CSSPlugin, ScrollToPlugin];


export default class LocalMarket {

    constructor() {

        if (!d.querySelector("#LocalMarketDetail")) {
            return;
        }

         
        if (d.querySelector("#IntroPartnerSlider")) {
            const slider = new Swiper(d.querySelector("#IntroPartnerSlider"), {
                speed: 400,
                spaceBetween: 25,
                slidesPerView: 'auto',
                freeMode: {
                    enabled: true,
                    sticky: true,
                    momentumRatio: 1.5
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }

        var jsonData = null;
        var initData = null;

        if (window.hasOwnProperty("mapJsonData")) {
            jsonData = JSON.parse(mapJsonData);
            initData = JSON.parse(mapInitPoint);

        }

        const loadCorrectModal = (currentTarget, btn) => {
            // var btn = evt.currentTarget.querySelector("a.more_info");

            Axios.get(`/api/pyc/IsClassFull?classid=${btn.dataset.classid}`).then((result) => {

                if (result.data != null) {

                    if (result.data == true) {
                        window.waitlistModalClass.OpenWaitlistModal(btn.dataset.organizationid, btn.dataset.classid, currentTarget);
                    } else {
                        window.registrationModal.OpenRegModal(btn.dataset.organizationid, btn.dataset.classid, currentTarget);
                    }

                }

            });
        }


        const allClasses = d.querySelectorAll(".class-card");
        allClasses.forEach((card, i) => {

            card.addEventListener("click", (e) => {

                var btn = e.currentTarget.querySelector("a.more_info");
                if (btn) {
                    loadCorrectModal(e.currentTarget, btn);
                }
            });
        });







    }
}